<template>

  <!-- Page Drawer -->
  <q-dialog
    full-width
    full-height
    ref="dialog"
    :value="value"
    @input="input"
    class="page-drawer"
    transition-hide="slide-up"
    transition-show="slide-down">

    <q-card
      class="page-drawer__body shadow-0">

      <div
        class="page-drawer__actions bs-px ibs-py">

        <q-btn
          flat
          round
          dense
          size="lg"
          color="black"
          @click="input(!value)">

          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="currentColor">

            <use
              xlink:href="/images/icons/icon-symbols.svg?v1#arrow-left"/>

          </svg>

        </q-btn>

      </div>

      <page-block
        class="page-drawer__block"
        wrapper-class="page-drawer__wrapper"
        overlay-class="q-pt-none overflow-hidden">

        <div
          class="text-h2 text-center text-bold">
          НАВИГАЦИЯ ПО САЙТУ
        </div>

        <div
          class="grid-4 q-mb-sm">

          <div
            @click="toHome"
            class="text-h2 text-weight-bold cursor-pointer">
            Главная
          </div>

        </div>

        <div
          class="page-drawer__menu grid-4 grid-gap-2">

          <universal-link
            :key="index"
            :to="item.link"
            :target="item.target"
            v-for="(item, index) in menu"
            class="page-drawer__menu-item"
            v-if="!item.position || item.position === 'dropdown'">

            <div
              class="text-h3 text-weight-bold">
              {{ item.title.ru }}
            </div>

          </universal-link>

        </div>

        <!-- Footer -->
        <div
          class="page-drawer__footer bs-mt">

          <!-- Logo -->
          <div
            @click="toHome"
            class="page-drawer__logo cursor-pointer">

            <img
              class="xs-hide"
              src="/images/logo/logo-light.svg"/>

            <img
              class="xs"
              src="/images/logo/logo-light-dense.svg"/>

          </div>

        </div>

      </page-block>

    </q-card>

  </q-dialog>

</template>

<script>

  import InputMixin from '@src/mixins/input-mixin';
  import PageBlock from 'components/page/page-block';

  export default {
    name: 'page-drawer',
    components: {PageBlock},
    props: [
      'menu',
      'value',
    ],
    mixins: [
      InputMixin,
    ],
    methods: {
      toHome() {

        this.input(false);
        this.$router.push('/').catch(() => {});
      },
    },
  };

</script>

<style lang="scss">

  .page-drawer {

    &__body {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    &__content {
      display: flex;
      flex-direction: column;
    }

    &__block {
      flex: 1;
    }

    &__wrapper {
      max-width: 900px;
      position: relative;

      &:before {
        top: 100px;
        z-index: 1;
        content: '';
        width: 250px;
        left: -250px;
        height: 100%;
        position: absolute;
        background-size: 200px;
        background-repeat: no-repeat;
        background-position: top left;
        background-image: url('/images/element/element-base.svg');
      }

      &:after {
        z-index: 2;
        top: 100px;
        content: '';
        width: 250px;
        height: 100%;
        right: -250px;
        position: absolute;
        background-size: 200px;
        background-repeat: no-repeat;
        background-position: top 3rem right 0;
        background-image: url('/images/element/element-vert-big.svg');
      }
    }

    &__footer {
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    &__logo img {
      height: 70px;
    }
  }

</style>
